import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  OnInit,
  signal,
} from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { finalize, Subscription, Subject, switchMap } from 'rxjs';

import {
  AppService,
  AppSettingsService,
  PostMessageService,
} from './shared/services/app';
import {
  AuthService,
  CommonService,
  SignalRService,
} from './shared/services/api';
import { ToastsComponent } from './layout/toasts/toasts.component';
import { AnnounceComponent, ReselectComponent } from './shared/components';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    ToastsComponent,
    AnnounceComponent,
    ReselectComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
  private _subscriptions$: Subscription[] = [];
  private _signalRService = inject(SignalRService);
  private _appService = inject(AppService);
  private _commonService = inject(CommonService);
  private _authService = inject(AuthService);
  private _appSettingsService = inject(AppSettingsService);
  private _postMessageService = inject(PostMessageService);
  private _route = inject(ActivatedRoute);

  firstLoading = signal(true);

  ngOnInit(): void {
    this._appService.loadCountries().subscribe();
    this._postMessageService.listenPluginMessage();
    this._postMessageService.registerPostMessageOnSizeChange();
    this._appService
      .loadAirports()
      .pipe(finalize(() => this.firstLoading.set(false)))
      .subscribe();
    this._authService.getContactInfo().subscribe();
    this.autoLogin();
    this._signalRService.connect();
    this._commonService.getExchangeRate();

    this._subscriptions$.push(
      this._route.queryParams.subscribe((params) => {
        if (params['code']) {
          this._appService.saveAgentCode(params['code']);
        }

        if (params['domain']) {
          this._appService.saveAgentDomain(params['domain']);
        }

        if (params['layoutType']) {
          console.log(`[${params['layoutType'].toUpperCase()}]`);
          this._appSettingsService.changeLayoutType(params['layoutType']);
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this._subscriptions$.forEach((sub) => sub?.unsubscribe());
    this._subscriptions$ = [];
  }

  private autoLogin(): void {
    this._subscriptions$.push(
      this._route.queryParams.subscribe((params) => {
        const { token, id } = params;
        if (token && id) {
          this._authService.autoLogin({
            token: decodeURIComponent(token),
            accId: decodeURIComponent(id),
          });
        } else {
          this._authService.autoLogin();
        }
      }),
    );
  }
}
